import CBLogo from '../images/favicon-cb.png';
import YBLogo from '../images/favicon-yb.png';
import VMLogo from '../images/favicon-vm.ico';
import BLogo from '../images/b-logo.png';

export const applyFaviconBasedOnBankId = brandId => {
  const head = document.querySelector('head');
  const favicon = document.createElement('link');
  favicon.type = 'image/x-icon';
  favicon.rel = 'shortcut icon';
  favicon.href =
    brandId === 'VM' ? VMLogo : brandId === 'B' ? BLogo : brandId === 'YB' ? YBLogo : CBLogo;

  favicon && head.appendChild(favicon);
  document.title = `Cash ISA Transfer | ${
    brandId === 'VM'
      ? 'Virgin Money'
      : brandId === 'B'
      ? 'B Bank'
      : brandId === 'CB'
      ? 'Clydesdale Bank'
      : 'Yorkshire Bank'
  }`;
};

//remove hash url paramater from the url
export const removeHashUrl = () => {
  if (window.history.pushState) {
    //use replaceState to update current url including # sign.
    window.history.replaceState('', '/', window.location.pathname);
  } else {
    window.location.hash = '';
  }
};

export const toTitleCase = inputString => {
  return typeof inputString === 'string'
    ? inputString.replace(
        /\w\S*/g,
        text => `${text.charAt(0).toUpperCase()}${text.substr(1).toLowerCase()}`
      )
    : inputString;
};

export const getAPIParameterValues = config => {
  const {
    configValues: { ibApiUrl },
    accessToken
  } = config;
  return {
    ibApiUrl,
    accessToken
  };
};
